import baseUrl from "../config/baseUrl";

const unAssignUser = async ({
  token,
  document_source_details,
  created_at,
  document_source_type,
  bulkAssignIds
}) => {
  let query_string = '';

  // Check for each parameter and append it if defined
  if (document_source_details !== undefined) {
    query_string += `document_source_details=${document_source_details}`;
  }
  if (created_at !== undefined) {
    // If there is already a parameter in the query, prepend "&"
    if (query_string) query_string += `&`;
    query_string += `created_at=${created_at}`;
  }
  if (document_source_type !== undefined) {
    if (query_string) query_string += `&`;
    query_string += `document_source_type=${document_source_type}`;
  }
  if (bulkAssignIds !== undefined) {
    if (query_string) query_string += `&`;
    query_string += `document_id=${bulkAssignIds}`;
  }

  try {
    // Ensure there's no leading "&" and append the query string with "?"
    const response = await fetch(
      `${baseUrl}/api/unassign-user?${query_string}`,
      {
        method: "PUT",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    return error;
  }
};

export default unAssignUser;
